var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"global-btn global-pbtn",staticStyle:{"border-radius":"5px"},attrs:{"depressed":"","large":"","width":_vm.width,"to":_vm.to,"loading":_vm.loading,"height":_vm.height,"color":_vm.btnColor,"disabled":_vm.disabled,"block":_vm.block}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }